<button class="hand-loader" tabindex="0" type="button" aria-label="Interact in 3D">

  <div class="hand-loader__container">
    <div class="hand-loader__circle"></div>
    <img class="hand-loader__3d-hand" src="assets/images/widget/loading_experience/interact-in-3d-hand.svg" alt="Interact in 3D">
    <div class="hand-loader__label" >Interact in 3D</div>
  </div>

</button>
